import React from 'react';
import { ReactComponent as accordionDown } from './assets/icons/accordion-down.svg';
import { ReactComponent as accordionLeft } from './assets/icons/accordion-left.svg';
import { ReactComponent as addLocation } from './assets/icons/add-location.svg';
import { ReactComponent as addPatient } from './assets/icons/patient-add.svg';
import { ReactComponent as address } from './assets/icons/address.svg';
import { ReactComponent as advice } from './assets/icons/advice.svg';
import { ReactComponent as allDocuments } from './assets/icons/all-documents.svg';
import { ReactComponent as appointmentsDown } from './assets/icons/appointments-down.svg';
import { ReactComponent as appointmentsUp } from './assets/icons/appointments-up.svg';
import { ReactComponent as arrow } from './assets/icons/arrow.svg';
import { ReactComponent as arrowBack } from './assets/icons/arrow-back.svg';
import { ReactComponent as arrowForward } from './assets/icons/arrow-forward.svg';
import { ReactComponent as astraZeneca } from './assets/icons/AstraZeneca.svg';
import { ReactComponent as astraZenecaLogo } from './assets/icons/AstraZeneca-logo.svg';
import { ReactComponent as back } from './assets/icons/back.svg';
import { ReactComponent as backRound } from './assets/icons/back-round.svg';
import { ReactComponent as barcode } from './assets/icons/barcode.svg';
import { ReactComponent as battery } from './assets/icons/battery-medium.svg';
import { ReactComponent as batteryFull } from './assets/icons/battery-full.svg';
import { ReactComponent as batteryLow } from './assets/icons/battery-low.svg';
import { ReactComponent as batteryNoData } from './assets/icons/battery-nodata.svg';
import { ReactComponent as brokenLink } from './assets/icons/broken-link.svg';
import { ReactComponent as calendar } from './assets/icons/calendar.svg';
import { ReactComponent as calendarRound } from './assets/icons/calendar-round.svg';
import { ReactComponent as cancel } from './assets/icons/cancel.svg';
import { ReactComponent as check } from './assets/icons/check.svg';
import { ReactComponent as checkRound } from './assets/icons/check-round.svg';
import { ReactComponent as chevronDown } from './assets/icons/chevron-down.svg';
import { ReactComponent as chevronDownRound } from './assets/icons/chevron-down-round.svg';
import { ReactComponent as chevronLeftRound } from './assets/icons/chevron-left-round.svg';
import { ReactComponent as chevronRightRound } from './assets/icons/chevron-right-round.svg';
import { ReactComponent as chevronUp } from './assets/icons/chevron-up.svg';
import { ReactComponent as chevronUpRound } from './assets/icons/chevron-up-round.svg';
import { ReactComponent as clock } from './assets/icons/clock.svg';
import { ReactComponent as close } from './assets/icons/close.svg';
import { ReactComponent as compliance } from './assets/icons/compliance.svg';
import { ReactComponent as contact } from './assets/icons/contact.svg';
import { ReactComponent as contract } from './assets/icons/contract.svg';
import { ReactComponent as contactRound } from './assets/icons/contact-round.svg';
import { ReactComponent as csv } from './assets/icons/csv.svg';
import { ReactComponent as deleteIcon } from './assets/icons/delete.svg';
import { ReactComponent as details } from './assets/icons/details.svg';
import { ReactComponent as desktopWindows } from './assets/icons/desktop-windows.svg';
import { ReactComponent as desktopAccessDisabled } from './assets/icons/desktop-access-disabled.svg';
import { ReactComponent as document } from './assets/icons/document.svg';
import { ReactComponent as documentEmpty } from './assets/icons/document-empty.svg';
import { ReactComponent as download } from './assets/icons/download.svg';
import { ReactComponent as drawer } from './assets/icons/drawer.svg';
import { ReactComponent as editData } from './assets/icons/edit-data.svg';
import { ReactComponent as error } from './assets/icons/error.svg';
import { ReactComponent as evinovaLogo } from './assets/icons/evinova-logo.svg';
import { ReactComponent as evinova } from './assets/icons/evinova.svg';
import { ReactComponent as exostarLogo } from './assets/icons/exostar-logo.svg';
import { ReactComponent as feedback } from './assets/icons/feedback.svg';
import { ReactComponent as file } from './assets/icons/file.svg';
import { ReactComponent as filter } from './assets/icons/filter.svg';
import { ReactComponent as firstPage } from './assets/icons/first-page.svg';
import { ReactComponent as folder } from './assets/icons/folder.svg';
import { ReactComponent as globe } from './assets/icons/globe.svg';
import { ReactComponent as menu } from './assets/icons/menu.svg';
import { ReactComponent as healthEvent } from './assets/icons/health-event.svg';
import { ReactComponent as homeVisit } from './assets/icons/home-visit.svg';
import { ReactComponent as icfTemplateMaster } from './assets/icons/icf-template-master.svg';
import { ReactComponent as icfLocalTemplateTranslated } from './assets/icons/icf-local-template-translated.svg';
import { ReactComponent as icfLocalTemplateNonTranslated } from './assets/icons/icf-local-template-non-translated.svg';
import { ReactComponent as icfLocalPlaceholderNonTranslated } from './assets/icons/icf-local-placeholder-non-translated.svg';
import { ReactComponent as icfLocalPlaceholderTranslated } from './assets/icons/icf-local-placeholder-translated.svg';
import { ReactComponent as importantDevices } from './assets/icons/important-devices.svg';
import { ReactComponent as inProcess } from './assets/icons/in-process.svg';
import { ReactComponent as info } from './assets/icons/info.svg';
import { ReactComponent as infoFilled } from './assets/icons/info-filled.svg';
import { ReactComponent as invalid } from './assets/icons/invalid.svg';
import { ReactComponent as lastConnection } from './assets/icons/last-connection.svg';
import { ReactComponent as lastPage } from './assets/icons/last-page.svg';
import { ReactComponent as lock } from './assets/icons/lock.svg';
import { ReactComponent as login } from './assets/icons/login.svg';
import { ReactComponent as logout } from './assets/icons/logout.svg';
import { ReactComponent as mail } from './assets/icons/mail.svg';
import { ReactComponent as medication } from './assets/icons/medication.svg';
import { ReactComponent as medicationPill } from './assets/icons/medication-pill.svg';
import { ReactComponent as medicationRound } from './assets/icons/medication-round.svg';
import { ReactComponent as gridMenu } from './assets/icons/grid-menu.svg';
import { ReactComponent as minus } from './assets/icons/minus.svg';
import { ReactComponent as missingDevice } from './assets/icons/missing-device.svg';
import { ReactComponent as mov } from './assets/icons/mov.svg';
import { ReactComponent as newPatientUp } from './assets/icons/new-patient-up.svg';
import { ReactComponent as newTab } from './assets/icons/new-tab.svg';
import { ReactComponent as newTabRound } from './assets/icons/new-tab-round.svg';
import { ReactComponent as noApp } from './assets/icons/no-app.svg';
import { ReactComponent as notificationCircle } from './assets/icons/notification-circle.svg';
import { ReactComponent as notificationOutlined } from './assets/icons/notification-outlined.svg';
import { ReactComponent as notificationPersonFilled } from './assets/icons/notification-person-filled.svg';
import { ReactComponent as patients } from './assets/icons/patients.svg';
import { ReactComponent as pdf } from './assets/icons/pdf.svg';
import { ReactComponent as pencil } from './assets/icons/pencil.svg';
import { ReactComponent as person } from './assets/icons/person.svg';
import { ReactComponent as personFilled } from './assets/icons/person-filled.svg';
import { ReactComponent as pin } from './assets/icons/pin.svg';
import { ReactComponent as plus } from './assets/icons/plus.svg';
import { ReactComponent as plusRound } from './assets/icons/plus-round.svg';
import { ReactComponent as png } from './assets/icons/png.svg';
import { ReactComponent as ppt } from './assets/icons/ppt.svg';
import { ReactComponent as profile } from './assets/icons/profile.svg';
import { ReactComponent as profileAvatar } from './assets/icons/profile-avatar.svg';
import { ReactComponent as questionnaire } from './assets/icons/questionnaire.svg';
import { ReactComponent as refresh } from './assets/icons/refresh.svg';
import { ReactComponent as reported } from './assets/icons/reported.svg';
import { ReactComponent as reportedEvent } from './assets/icons/reported-event.svg';
import { ReactComponent as role } from './assets/icons/role.svg';
import { ReactComponent as sampleCollection } from './assets/icons/sample-collection.svg';
import { ReactComponent as schedule } from './assets/icons/schedule.svg';
import { ReactComponent as search } from './assets/icons/search.svg';
import { ReactComponent as settings } from './assets/icons/settings.svg';
import { ReactComponent as site } from './assets/icons/site.svg';
import { ReactComponent as smartphone } from './assets/icons/smartphone.svg';
import { ReactComponent as smartphoneRound } from './assets/icons/smartphone-round.svg';
import { ReactComponent as sortByDown } from './assets/icons/sort-by-down.svg';
import { ReactComponent as sortByUp } from './assets/icons/sort-by-up.svg';
import { ReactComponent as status } from './assets/icons/status.svg';
import { ReactComponent as studyHelp } from './assets/icons/study-help.svg';
import { ReactComponent as studyProgress } from './assets/icons/study-progress.svg';
import { ReactComponent as studyStatus } from './assets/icons/study-status.svg';
import { ReactComponent as studyStatusRound } from './assets/icons/study-status-round.svg';
import { ReactComponent as submitted } from './assets/icons/submitted.svg';
import { ReactComponent as success } from './assets/icons/success.svg';
import { ReactComponent as sunglasses } from './assets/icons/sunglasses.svg';
import { ReactComponent as support } from './assets/icons/support.svg';
import { ReactComponent as supportFilled } from './assets/icons/support-filled.svg';
import { ReactComponent as team } from './assets/icons/team.svg';
import { ReactComponent as termsConditions } from './assets/icons/terms-conditions.svg';
import { ReactComponent as temporaryInformedConsent } from './assets/icons/temporary-informed-consent.svg';
import { ReactComponent as timeline } from './assets/icons/timeline.svg';
import { ReactComponent as timer } from './assets/icons/timer.svg';
import { ReactComponent as unfoldMore } from './assets/icons/unfold-more.svg';
import { ReactComponent as unifyLogoBackground } from './assets/icons/unify-logo-background.svg';
import { ReactComponent as unifyLogoOnly } from './assets/icons/unify-logo-only.svg';
import { ReactComponent as unifyWithIcon } from './assets/icons/unify-with-icon.svg';
import { ReactComponent as upload } from './assets/icons/upload.svg';
import { ReactComponent as verified } from './assets/icons/verified.svg';
import { ReactComponent as visibility } from './assets/icons/visibility.svg';
import { ReactComponent as visibilityOff } from './assets/icons/visibility-off.svg';
import { ReactComponent as warning } from './assets/icons/warning.svg';
import { ReactComponent as warningRound } from './assets/icons/warning-round.svg';
import { ReactComponent as warningUpRound } from './assets/icons/warning-up.svg';
import { ReactComponent as water } from './assets/icons/water.svg';

type IconType = { [key: string]: React.FunctionComponent<React.SVGProps<SVGSVGElement>> };

export const icons: IconType = {
  accordionDown,
  accordionLeft,
  addLocation,
  addPatient,
  address,
  advice,
  allDocuments,
  appointmentsDown,
  appointmentsUp,
  arrow,
  arrowBack,
  arrowForward,
  astraZeneca,
  astraZenecaLogo,
  back,
  backRound,
  barcode,
  battery,
  batteryFull,
  batteryLow,
  batteryNoData,
  brokenLink,
  calendar,
  calendarRound,
  cancel,
  check,
  checkRound,
  chevronDown,
  chevronDownRound,
  chevronLeftRound,
  chevronRightRound,
  chevronUp,
  chevronUpRound,
  clock,
  close,
  compliance,
  contact,
  contract,
  contactRound,
  csv,
  deleteIcon,
  details,
  desktopWindows,
  desktopAccessDisabled,
  document,
  documentEmpty,
  download,
  drawer,
  editData,
  error,
  evinova,
  evinovaLogo,
  exostarLogo,
  feedback,
  file,
  filter,
  firstPage,
  folder,
  globe,
  healthEvent,
  homeVisit,
  importantDevices,
  inProcess,
  info,
  infoFilled,
  icfLocalPlaceholderNonTranslated,
  icfLocalPlaceholderTranslated,
  icfLocalTemplateNonTranslated,
  icfLocalTemplateTranslated,
  icfTemplateMaster,
  invalid,
  lastConnection,
  lastPage,
  lock,
  login,
  logout,
  mail,
  medication,
  medicationPill,
  medicationRound,
  gridMenu,
  minus,
  missingDevice,
  mov,
  newPatientUp,
  newTab,
  newTabRound,
  noApp,
  notificationCircle,
  notificationOutlined,
  notificationPersonFilled,
  patients,
  pdf,
  pencil,
  person,
  personFilled,
  pin,
  plus,
  plusRound,
  png,
  ppt,
  profile,
  profileAvatar,
  questionnaire,
  refresh,
  reported,
  reportedEvent,
  role,
  sampleCollection,
  schedule,
  search,
  settings,
  site,
  smartphone,
  smartphoneRound,
  sortByDown,
  sortByUp,
  status,
  studyHelp,
  studyProgress,
  studyStatus,
  studyStatusRound,
  submitted,
  success,
  sunglasses,
  support,
  supportFilled,
  team,
  temporaryInformedConsent,
  termsConditions,
  timeline,
  menu,
  timer,
  unfoldMore,
  unifyLogoBackground,
  unifyLogoOnly,
  unifyWithIcon,
  upload,
  verified,
  visibility,
  visibilityOff,
  warning,
  warningRound,
  warningUpRound,
  water,
};
